// extracted by mini-css-extract-plugin
module.exports = {"paper":"Task_paper__O6tG-","buttons":"Task_buttons__25Csl"};